// extracted by mini-css-extract-plugin
export default {"badge-button":"_1XAhO","badgeButton":"_1XAhO","badge":"O-1jK"};